import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import {
  AdminAgenciesResponse,
  AdminAgency,
  CreateAgencyPayload,
  UpdateAgencyPayload,
} from './admin-agencies.types';

/** Platform-admin agency administration: list, create (+ founding admin), rename / toggle. */
@Injectable({ providedIn: 'root' })
export class AdminAgenciesService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}/api/admin/agencies`;

  list(): Observable<AdminAgenciesResponse> {
    return this.http.get<AdminAgenciesResponse>(`${this.base}/`);
  }

  /** Create an agency and its founding ADMIN (emailed a set-password invite). */
  create(payload: CreateAgencyPayload): Observable<AdminAgency> {
    return this.http.post<AdminAgency>(`${this.base}/`, payload);
  }

  /** Rename an agency or toggle its active kill switch. */
  update(shortId: string, payload: UpdateAgencyPayload): Observable<AdminAgency> {
    return this.http.patch<AdminAgency>(`${this.base}/${shortId}/`, payload);
  }
}
